import "./styles/index.css";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { APIProvider } from "@vis.gl/react-google-maps";
import { env } from "@/config/env";
import { TourProvider } from "@/contexts/tour.context";

import { routeTree } from "./routeTree.gen";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_URL,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/, "https://expresso.codifylabs.dev"],

  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

const router = createRouter({
  routeTree,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <APIProvider apiKey={env.VITE_GOOGLE_MAPS_API}>
        <QueryClientProvider client={queryClient}>
          <TourProvider>
            <RouterProvider router={router} />
          </TourProvider>
        </QueryClientProvider>
      </APIProvider>
    </StrictMode>
  );
}
